import { ColoredButton } from '@components/colored-elements';
import { rbac } from '@lib/common';
import { Grid, Tooltip } from '@material-ui/core';
import { lightGreen, red, blue } from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/CancelRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useToggle } from '@lib/common';
import { useSnackbar } from 'notistack';
import { DeleteC3RelationDialog } from '../search/columns';

export function FormActions({
  submitForm = null,
  redirectToSearch = () => {},
  c3FormData,
  vtr_id,
}) {
  const form = useFormContext();
  const history = useHistory();
  const [editOpen, , showEditDialog, hideEditDialog] = useToggle(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSave = useCallback(() => {
    submitForm && submitForm();
  }, [submitForm]);

  /*   const { is_email_verified = false, currently_working = ''} = c3FormData
   */
  return (
    <Grid container spacing={2}>
      <Grid item xs>
        &nbsp;
      </Grid>
      <Grid item>
        <ColoredButton
          colored={red[500]}
          coloredHover={red[900]}
          startIcon={<CancelIcon />}
          variant="contained"
          size="small"
          // className={classes.paddingAll}
          onClick={() => history.push('/c3-page/search')}>
          Cancel
        </ColoredButton>
      </Grid>
      <Grid item>
        <ColoredButton
          colored={lightGreen[700]}
          coloredHover={lightGreen[900]}
          startIcon={<SaveIcon />}
          variant="contained"
          size="small"
          //  disabled={rbac('C3_Edit', '', 'Button')}
          onClick={onSave}>
          Save
        </ColoredButton>
      </Grid>
      {/* <Grid item>
        <DeleteC3RelationDialog
          contentPersonRelationId={vtr_id}
          deleteDisable={true} 
          deleteC3
          isButton={true}
        />
      </Grid> */}
    </Grid>
  );
}
